import { useMutation } from '@apollo/client'
import { BucketAlbumsMoveDocument } from '../../../graphql/generated'
import logger from '../../../utils/logger'
import useAlerts from './useAlerts'

export default function useBucketAlbumsMove() {
  const { createAlert } = useAlerts()
  const [mutation, results] = useMutation(BucketAlbumsMoveDocument, {
    onError: (e) => {
      e.graphQLErrors.forEach((error) => {
        switch (error.extensions?.code) {
          default:
            createAlert(error.message, 'error', error)
        }
      })

      if (!e.graphQLErrors) {
        logger.error(e)
        createAlert('There was a problem moving your album. Please try again later.')
      }
    },
    onCompleted: () => {
      createAlert('Album has been moved!', 'success')
      logger.info('success')
    }
  })

  return { mutation, results }
}
